module.exports = __webpack_public_path__ + "static/pic02-5de04f7b4be59fecb0ef55f1362cd15a.jpg";